import axios from '@/lib/axios';
import { PurchaseOrderContractTaskDocument } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 0900. 発注案件契約タスクファイル名編集
 * [PUT] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/purchase_order_contract_tasks/:task_id/purchase_order_contract_task_documents/:id/
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  task_id: number;
  id: number;
  name: string;
};

const updatePurchaseOrderContractTaskDocument = (props: Props): Promise<PurchaseOrderContractTaskDocument> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/purchase_order_contract_tasks/${props.task_id}/purchase_order_contract_task_documents/${props.id}`,
    props
  );
};

export const useUpdatePurchaseOrderContractTaskDocument = () => {
  return useMutation({
    mutationFn: updatePurchaseOrderContractTaskDocument,
  });
};
